
<script setup>
    import { ref, computed, reactive, onMounted, onUnmounted, watch } from 'vue'
    import { formatToTimeZone } from 'date-fns-timezone';
    import { onAuthStateChanged } from "firebase/auth";
    import { ref as databaseRef, onValue, update, push, child, set } from "firebase/database";
    import { ref as storageRef, uploadBytes } from "firebase/storage";
    import { useRoute } from 'vue-router'
    import HeaderComponent from '../../components/common/HeaderComponent.vue'
    import NavigationBar from '../../components/business/NavigationBar.vue'
    import DefaultModalComponent from '../../components/common/DefaultModalComponent.vue'
    import PaginateComponent from 'vuejs-paginate-next'
    import Firebase from "../../firebase_settings/index.js"
    import Error from "../../firebase_settings/error.js"
    import utilFunctions from "../../firebase_settings/utils.js"
    import Papa from 'papaparse';

    const DATEFORMAT = 'YYYYMMDD'
    const TIME_ZONE_TOKYO = 'Asia/Tokyo';
    const auth = Firebase.auth
    const database = Firebase.database;
    const storage = Firebase.storage;
    const route = useRoute()
    const IMAGEMAXNUM = 5 //顔画像最大登録枚数

    //利用者情報のリアクティブオブジェクト
    const reactiveObj = reactive({
        //企業ID
        corporateId: "",
        //登録者一覧
        registrants: [],
        //更新対象の登録者
        newRegistrants: [],
        //アップロード画像
        newImages: [],
        //再レンダリング用のキー
        renderKey: 0,
        //現在のページ（デフォルトは１ページ）
        currentPage: 1,
        //姓名フラグ
        UseNameFlag1: false,
        //セイメイフラグ
        UseNameFlag2: false,
        //ローディング
        loadingFlag: false,
        //登録処理結果
        outputData: "",
        //削除フラグ
        deleteFlag: false,
        //モーダル開閉
        modalFlag: false,
        //モーダルに表示するメッセージ
        modalMessage: "",
        //モーダルの再描画用のキー
        modalRenderkey: 0,
        //重複チェックフラグ
        duplicateFlag: false,
        //重複時に表示するメッセージ
        duplicateMessage: "",
        //デフォルトモーダルウィンドウのCSS等をカスタマイズするオブジェクト
        otherObject: {},
        //編集ボタン押下時のID変更許諾フラグ
        userEditFlag: false,
        //画像アップロードフラグ
        imageFlag: false,
        //登録時の分母
        denominatorCount: 0,
        //登録時の分子
        numeratorCount: 0,
        //アプリ設定情報
        appSetting: {},
        //端末一覧
        Terminals: {},
        //tips表示フラグ(解錠可能時間)
        tipsUserOpenFlag: false,
        //tips表示フラグ(画像ファイル)
        tipsImgFlag: false,
    })
    const reactiveCountObj = reactive({
        countFlag: false
    })
    //利用者の個別登録関連のリアクティブオブジェクト
    const reactiveRegistObj = reactive({
        //利用者のインデックス番号
        index: undefined,
        //新規登録に関するフラグ
        newRegistFlag: false,
        //新規登録者を格納するオブジェクト
        newRegistrants: {
            ID: '',
            FirstName1: '',
            LastName1: '',
            FirstName2: '',
            LastName2: '',
            Email: '',
            UserOpenFlag: false,
            UserOpenStart: 0,
            UserOpenEnd: 0,
            FaceUrl: [``],
            FaceStatus: [``],
            UserGroup: []
        },
        //解錠可能時間の情報を格納するオブジェクト
        UserOpenObj: {
            StartHour: 0,
            StartMinute: 0,
            EndHour: 0,
            EndMinute: 0
        },
        //新規登録者の画像
        newImages: []
    })
    // 画像ファイル整合性確認オブジェクト
    const reactiveImageFile = reactive({
        //画像ファイル整合性チェック 注意確認同意
        confirmFlg :false,
        //アップロードファイル存在フラグ
        uploadFileFlg: false,
        //画像ファイル整合性確認フラグ
        chkImgFileFlg: false,
        //画像ファイル整合性チェック内容
        errImgFile: "",
        //モーダル表示
        message:{
            "noImgName": "画像ファイル名を記載していない利用者がいます。<br>登録処理を続行してもよろしいでしょうか",
            "errImgName": "画像ファイルがアップロードされていない利用者がいます。<br>登録処理を続行してもよろしいでしょうか"
        }

    })
    const imageLabelText = ref('参照')
    const imageLabelsText = ref('画像ファイル参照')
    const csvLabelText = ref('CSVファイル参照')

    const FaceStatusDict = {
        'NOTREG': 0,
        'REG': 1,
        'CMPREAD': 2,
        'NOTEMB': 3,
        'READING': 4 
    }
    //1ページに表示する件数
    const perPage = 10;
    //firebaseから登録者一覧を取得
    const getRegstrants = async () => {
        if(reactiveObj.corporateId) {
            const regstrantsRef = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/User`);
            //firebaseから登録者を取得する（戻り値はリスナー解除関数）
            return onValue(regstrantsRef, async (snapshot) => {
                const Regstrants = (snapshot.val());
                reactiveObj.registrants = [];
                for(let key in Regstrants) {
                    reactiveObj.registrants.push({
                        userId: key,
                        Id: Regstrants[key]['Id'],
                        FirstName1: Regstrants[key]['FirstName1'],
                        LastName1: Regstrants[key]['LastName1'],
                        FirstName2: Regstrants[key]['FirstName2'],
                        LastName2: Regstrants[key]['LastName2'],
                        Email: Regstrants[key]['Email'],
                        UserGroup: Regstrants[key]['UserGroup'],
                        FaceUrl: Regstrants[key]['FaceUrl'].map(path => path.split('/').pop()), //${uid}/は取り除く
                        //FaceUrl: Regstrants[key]['FaceUrl'],
                        FaceStatus: Regstrants[key]['FaceStatus'],
                        FaceStatus2: Regstrants[key]['FaceStatus2'] ? Regstrants[key]['FaceStatus2'] : {},
                        FingerFlag: Regstrants[key]['FingerFlag'],
                        PINFlag: Regstrants[key]['PINFlag'],
                        NFCFlag: Regstrants[key]['NFCFlag'],
                        UserOpenFlag:Regstrants[key]['UserOpenFlag'],
                        UserOpenStart:Regstrants[key]['UserOpenStart'],
                        UserOpenEnd:Regstrants[key]['UserOpenEnd'],
                        LatestUpdated: Regstrants[key]['LatestUpdated']
                    })
                }
                //更新順に並べ替え
                reactiveObj.registrants = reactiveObj.registrants.sort((element, nextElement) => {
                    return (element['LatestUpdated'] > nextElement['LatestUpdated']) ? -1 : 1;
                })
            })
            reactiveObj.renderKey++
        }
    }
    const displayTouchInfo = (Regstrants) => {
        const displayInfo = []
        Regstrants.NFCFlag ? displayInfo.push('N') : null
        Regstrants.FingerFlag ? displayInfo.push('指') : null
        Regstrants.PINFlag ? displayInfo.push('暗') : null
        return displayInfo.length ? displayInfo.join('・') : '未登録'
    }
    //ページネーションを押下した時
    const clickCallback = (pageNum) => {
        reactiveObj.currentPage = Number(pageNum);
    }
    //CSVファイルアップロード処理
    const fileUpload = (e) => {
        reactiveObj.newRegistrants = []
        let fileChecker = 0
        const file = e.target.files[0];
        //拡張子でバリデーション
        const extentionRegExp = new RegExp(/.*\.csv$/, 'i')
        if(!extentionRegExp.test(file['name'])) {
            alert(Error.errorResult({ code: 'RVE0003'}, route.name))
            return;
        }
        const reader = new FileReader();
        const loadFunc = () => {
            //改行毎に配列に分解
            const results = Papa.parse(reader.result, {
                header: false,
                skipEmptyLines: false
            });
            const lines = results.data.slice(1); // ヘッダー行を除外
            
            //登録人数が上限以内かチェック
            if(lines.length/2 > 101) {
                fileChecker = 1
            }
            //CSVの1行分に対して正規表現でチェック
            //UserGroupが固定の時
            const fieldDefinitions = [
            {
               name: 'ID',
               index: 0,
               required: true,
               validate: field => {
                const isValid = field.trim() !== ''
                return {
                    valid: isValid,
                    message: isValid ? '' : 'IDを入力してください'
                }
               }
            },
            {
                name: 'メールアドレス',
                index: 5,
                required: true,
                validate: field => {
                    const isValid = /^[a-z\d][\w.+_-]+@[\w.-]+\.[a-z\d]+$/i.test(field)
                    return {
                        valid: isValid,
                        message: isValid ? '' : 'メールアドレスを正しい形式で入力してください'
                    }
                }
            },
            {
                name: '解錠可能開始時間',
                index: 7,
                required: false,
                validate: field => {
                    return {
                        valid: true,
                        message: ''
                    }
                }, //データ形式のチェックは入力値チェックとまとめて実施するので、ここではチェックなし(true)
                checkQuarter: true
            },
            {
                name: '解錠可能終了時間',
                index: 8,
                required: false,
                validate: field => {
                    return {
                        valid: true,
                        message: ''
                    }
                }, //データ形式のチェックは入力値チェックとまとめて実施するので、ここではチェックなし(true)
                checkQuarter: true
            },
            {
                name: '画像ファイル',
                index: 9,
                required: false,          
                validate: field => {
                    if (!field || field.trim() === '') return {valid: true, message:""}; // 空欄はOK
                    const files = field.replace(/^"+|"+$/g, '').split(',').map(f => f.trim()); //,区切りのファイル名を分割
                    //画像ファイルを上限値以上選択していた場合、NG
                    if (files.length > IMAGEMAXNUM) return {valid: false,  message: `登録できる画像ファイルは利用者1人につき${IMAGEMAXNUM}枚までです。`}
                    //ファイルの拡張子チェック
                    const isValid = files.every(f => /^.*\.(jpg|jpeg|png)$/i.test(f))
                    return {
                        valid: isValid,
                        message: isValid ? '' : '画像ファイルの拡張子はjpeg、jpg、pngのみ対応しています'
                    }
               }
            }];
            
            //CSVファイルを1行ずつチェック
            const errors = [];
            lines.forEach((fields, index) => {
                const isAllEmpty = fields.every(f => (f ?? '').trim() === ''); //全フィールド空かチェック
                if (isAllEmpty) return; // 全フィールド空(空白行)ならスキップ      
                //各データを正規表現でチェック
                const lineErrors = [];
                fieldDefinitions.forEach((def) => {
                    const field = fields[def.index] || '';
                    const result = def.validate(field);
                    if (!result.valid) {
                        //データエラーはエラー内容を記録する
                        lineErrors.push({
                            message: result.message || `${def.name}の値が不正です`
                        });
                    }
                    else if((def.checkQuarter) && (fields[6].toUpperCase() === 'ON')){
                        if (field === "") {
                            lineErrors.push({
                                message: `${def.name}を入力してください`
                            });
                        }
                        else if(!(/^([\d]{1,2}:[\d]{2})?$/.test(field))){
                            lineErrors.push({
                                message: `${def.name}はHH:mm形式の数値で入力してください`
                            });
                        }
                        else{
                            const minute = Number(field.split(/[：:]/g)[-1])
                            if (minute % 15 !== 0){
                                lineErrors.push({
                                    message: `${def.name}は15分刻みで入力してください`
                                });
                            }
                        }
                    }
                });

                if (lineErrors.length > 0) {
                //データエラーがあった場合、エラーのあった行を記録する
                    errors.push({
                        lineNumber: index + 1,
                        issues: lineErrors
                    });
                    fileChecker = 2
                }
            });
            
            //データに不備がない
            if(!fileChecker) {
                lines.forEach(data => {
                    let newData = {}
                    const isAllEmpty = data.every(field => field.trim() === '');//全フィールド空かチェック
                    if (isAllEmpty) return; //空白分はスキップ
                    //画像ファイル名を配列に変換
                    const faceUrls = (data[9] ?? '').trim() === ''
                        ? ['']
                        : data[9].replace(/^"+|"+$/g, '').split(',').map(url => url.trim()).filter(url => url !== '');

                    //項目が11個（ID、姓、名、セイ、メイ、メールアドレス、個別解錠、解錠可能開始時間、解錠可能終了時間、所属、画像URL）の時
                    //項目が10個（ID、姓、名、セイ、メイ、メールアドレス、個別解錠、解錠可能開始時間、解錠可能終了時間、画像URL）の時
                    if(data.length >= 10) {
                        newData = {
                            'Id': data[0],
                            'LastName1': data[1],
                            'FirstName1': data[2],
                            'LastName2': data[3],
                            'FirstName2': data[4],
                            'Email': data[5],
                            'UserOpenFlag': data[6].toUpperCase() === 'ON' ? true : false, //半角/全角に依らないよう、半角に直して判定
                            'UserOpenStart': Number(data[7].replace(/[：:]/g, "")),
                            'UserOpenEnd': Number(data[8].replace(/[：:]/g, "")),
                            //以下はUserGroupが固定であるとき
                            'UserGroup': ['All'],
                            'FaceUrl': faceUrls,
                            //'FaceStatus': data[9] || false
                            'FaceStatus': faceUrls,
                            //以下はUserGroupがカスタマイズ可能であるとき
                            //'UserGroup': data[9].replace(/^\[|\]$/g, '').split(',').map(s => s.trim()))),
                            //'FaceUrl': faceUrls,
                            //'FaceStatus': faceUrls,
                        }
                    };
                    reactiveObj.newRegistrants.push(newData);
                    //更新対象の登録者がいる場合、ラベル名を変更
                    if(reactiveObj.newRegistrants.length > 0) {
                        csvLabelText.value = '選択済';
                    }
                });
            }
            //1行でも適していなければエラーとする
            else {
                //100人を超えて登録しようとした
                fileChecker == 1 ? alert(Error.errorResult({ code: 'RVE0008'}, route.name)) : null
                //CSVファイルのデータに不備あり
                if(fileChecker == 2){
                    // データの不備をまとめて表示(行番号、エラー内容)
                    let alertMsg = ['行番号,エラー内容']
                    errors.forEach((error) => {
                        error.issues.forEach((issue) => {
                            alertMsg.push(`${error.lineNumber + 1},${issue.message}`)
                        })
                    })
                    alert(Error.errorResult({ code: 'RVE0004'}, route.name))
                    //エラーメッセージをCSVファイルに出力
                    const filename =`result_csvupload_${formatToTimeZone(Date.now(), DATEFORMAT, { timeZone: TIME_ZONE_TOKYO })}.csv`
                    const bom = new Uint8Array([0xef, 0xbb, 0xbf])
                    const blob = new Blob([bom, alertMsg.join('\n')], { type: "text/csv" });
                    
                    //リンク先にダウンロード用リンクを指定する
                    const link = document.createElement('a')
                    link.download = filename
                    link.href = URL.createObjectURL(blob)
                    link.click()
                    //createObjectURLで作成したオブジェクトURLを開放する
                     URL.revokeObjectURL(link.href)
                }
                reactiveObj.newRegistrants = []
                csvLabelText.value = 'CSVファイル参照';
                reactiveObj.renderKey++
            }
        };
        reader.onload = loadFunc;
        //文字化け防止
        reader.readAsText(file)
    }
    // Tips表示(解錠可能時間)
    const tipsHoverUserOpen = () => {
        reactiveObj.tipsUserOpenFlag = true
    }
    //Tips非表示(解錠可能時間)
    const tipsLeaveUserOpen = () => {
        reactiveObj.tipsUserOpenFlag = false
    }
    // Tips表示(画像ファイル)
    const tipsHoverImg = () => {
        reactiveObj.tipsImgFlag = true
    }
    //Tips非表示(画像ファイル)
    const tipsLeaveImg = () => {
        reactiveObj.tipsImgFlag = false
    } 
    //画像アップロード処理
    const imageUpload = (event) => {
        try {
            const files = Array.from(event.target.files)
            //画像の上限値をチェック
            //(単体登録の時のみ、一括登録の時はアップロード時に確認)
            if(event.target.id == "imageButton" && files.length > IMAGEMAXNUM){
                alert(Error.errorResult({ code: 'RVE0010'}, route.name, {imageMaxNum: IMAGEMAXNUM}))
                return
            }
            //対応拡張子を.jpeg .jpg .pngにバリデーション
            const regexp = new RegExp(/.*\.jpg$|.*\.jpeg$|.*\.png$/, 'i')
            //拡張子チェッカー
            let checkFlag = false

            //画像再選択の可能性があるので、一旦初期化
            event.target.id == "imageButtons" ? reactiveObj.newImages = [] : reactiveRegistObj.newImages = []
            for(let index in files) {
                //10MBかつ対応している拡張子の画像のみを保持する
                if(regexp.test(files[index]['name']) && files[index]['size'] <= 10485760) {
                    //画像ファイル名をキーにして追加（更新）フラグを追加
                    event.target.id == "imageButtons" ? reactiveObj.newImages.push(files[index]) : reactiveRegistObj.newImages.push(files[index])
                    reactiveObj.imageFlag = true
                }
                else {
                    checkFlag = true
                }
            }
            if(checkFlag) {
                alert(Error.errorResult({ code: 'RVE0001'}, route.name))
            }
            //アップロード可能な画像がある場合、ラベル名を変更
            if(reactiveObj.newImages.length > 0){
                imageLabelsText.value = '選択済<br>(再選択)'
                csvLabelText.value = csvLabelText.value
            }
            if(reactiveRegistObj.newImages.length > 0)
                imageLabelText.value = '選択済<br>(再選択)'
            reactiveObj.renderKey++
        }
        catch {
            alert(Error.errorResult({ code: 'RVE0002'}, route.name))
            event.target.id == "imageButtons" ? imageLabelsText.value = '画像ファイル参照' : imageLabelText.value = '参照'
            event.target.id == "imageButtons" ? reactiveObj.newImages = [] : reactiveRegistObj.newImages = []
            reactiveObj.renderKey++
        }
    }
    //アップロード処理
    const uploadExec = async() => {
        //更新対象が0かつもしくは更新画像がない場合
        if(reactiveObj.newRegistrants.length == 0 && reactiveObj.newImages.length == 0) {
            alert(Error.errorResult({ code: 'RVE0005'}, route.name))
        }
        else {//更新対象が1人以上もしくは更新画像がある場合
            
            //一括登録の時の画像上限チェック
            const imageNumMax = IMAGEMAXNUM * reactiveObj.newRegistrants.length
            if(imageNumMax != 0 && imageNumMax < reactiveObj.newImages.length) {
                //　登録人数が0(imageNumMax=0×1人あたりの上限枚数)以外
                // かつ画像上限枚数を超えている(imageNumMax=登録人数×1人あたりの上限枚数)
                // 登録前に画像ファイルの枚数チェックをしているので、単体登録はこのルートを通らない、
                alert(Error.errorResult({ code: 'RVE0010'}, route.name, {imageMaxNum: IMAGEMAXNUM}))
                return
            }
            reactiveObj.loadingFlag = true
            await userUpdate()
            // アップロードした画像ファイルの存在確認NG
            if(reactiveImageFile.uploadFileFlg){
                // 画像ファイル整合性確認オブジェクト関連フラグを初期化
                reactiveImageFile.chkImgFileFlg = false
                reactiveImageFile.uploadFileFlg = false
                reactiveImageFile.errImgFile = ""

                return
            }
            // 画像ファイルの整合性確認NG
            if(reactiveImageFile.chkImgFileFlg) {
                // 確認モーダルを表示する
                reactiveObj.otherObject = {
                    confirm: '続行',
                }
                //メッセージ内容は整合性確認のエラー内容によって出しわける
                showDefaultModal(reactiveImageFile.message[reactiveImageFile.errImgFile])
                reactiveImageFile.confirmFlg = true

                // 画像ファイルの整合性確認 関連フラグの初期化
                reactiveImageFile.chkImgFileFlg = false
                reactiveImageFile.errImgFile = ""
                return
            }
            //ファイル選択が再発火できるようにリセットを行う
            resetExec();
        }
        reactiveObj.renderKey++;
    }
    //登録処理完了時にCSVを吐き出す際に実行
    const outputCSVData = (csvData, format = false) => {
        //UserGroupなし
        csvData = format ? 'Id（社員番号等）,姓,名,セイ,メイ,Email,個別解錠,解錠可能開始間,解錠可能終了時間,画像ファイル名' : csvData
        //UserGroupあり
        //csvData = format = 'Id（社員番号等）,姓,名,セイ,メイ,Email,個別解錠,解錠可能開始間,解錠可能終了時間,所属,画像ファイル名'
        const filename = format? 'format.csv' : `result_${formatToTimeZone(Date.now(), DATEFORMAT, { timeZone: TIME_ZONE_TOKYO })}.csv`
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, csvData], { type: "text/csv" })
        //リンク先にダウンロード用リンクを指定する
        const link = document.createElement('a')
        link.download = filename
        link.href = URL.createObjectURL(blob)
        link.click()

        //createObjectURLで作成したオブジェクトURLを開放する
        URL.revokeObjectURL(link.href)
    }
    //APIの実行
    const callUtilFunction = async (resultMessage, functionName, data) => {
        await utilFunctions.callFirebaseFunction(functionName, data)
        .then((result) => {
            //　登録エラーのみCSVファイル返却
            if(result.data.csvData) {
                reactiveObj.outputData = result.data.csvData
                // モーダルに表示するメッセージを変更
                resultMessage = '登録処理が完了しましたが、一部登録できていない利用者がいます。<br>CSVを出力しますので結果をご確認ください。'
            }
            if(result.data.result == 'images NG'){
                // モーダルに表示するメッセージを変更
                resultMessage = '登録処理を完了しましたが、顔画像が登録されておりません。<br> 顔画像の登録をお願いいたします。'
            }
            if(functionName == "deleteUser"){
                //削除後にページ数が減った場合の調整
                adjustPagecount()
            }
            showDefaultModal(resultMessage)
        })
        .catch((error) => {
            showDefaultModal(Error.errorResult(error.details, route.name))
        })
    }
    const chknewImages = () => {
        // アップロード画像がなければ、チェックOKとする
        // 正当性は、その後の画像ファイル整合性チェックで確認
        if(reactiveObj.newImages.length == 0) return true

        // 全アップロード画像をチェック
        for (const image of reactiveObj.newImages){
            let allMatch = false // チェックフラグ
            const name = image.name; // 画像ファイル名

            // 全登録利用者の画像ファイル名を確認
            for (const registrant of reactiveObj.newRegistrants) {
                const faceStatusList = registrant.FaceStatus;
                // 画像ファイル名の記載のない利用者はスキップ
                if((faceStatusList.length == 0) || 
                    ((faceStatusList.length == 1) && (faceStatusList[0] == ""))) continue;
                // 画像ファイル名が利用者の画像ファイル名に記載があったら、終了
                if (faceStatusList.includes(name)) {
                    allMatch = true;
                    break;
                }
            }
            // どの利用者の画像ファイル名にも記載がなかったら、チェックNG
            if(!allMatch) return false
        }
        // 全ファイル存在していたら、チェックOK
        return true
    }

    const checkMail = (targetUser) => {
        for(let registUser of reactiveObj.registrants) {
            //変更したい利用者のEメールと既存の利用者のEメールが一致しているかつ、IDが異なる場合
            if(registUser.Email == targetUser.Email && registUser.Id != targetUser.Id) {
                reactiveObj.duplicateFlag = true
                reactiveObj.duplicateMessage += `対象者:ID（${targetUser.Id}） Eメール（${targetUser.Email}）\n既存者:ID（${registUser.Id}） Eメール（${registUser.Email}）\n=================================\n`
                return true
            }
        }
        return false
    }
    //画像ファイル整合性チェック
    const chkImagefile = (targetUser) => {
        //確認モーダルで確認済みの時は、チェックOK
        if(reactiveImageFile.confirmFlg) return false

        //単体登録の場合は、確認モーダルでユーザーが確認済なので、チェックOK
        if(reactiveRegistObj.newRegistFlag) return false
        
        //CSVファイルに記載の画像ファイル名
        const imageNames = Object.values(targetUser['FaceStatus'])
        //画像ファイル名の記載がなければ、NG(確認モーダルで注意喚起)
        if ((imageNames.length == 0) || (imageNames.length == 1) && (imageNames[0] === ""))
        {
            reactiveImageFile.chkImgFileFlg = true
            reactiveImageFile.errImgFile = "noImgName"
            return true
        }
            
        //記載された画像ファイル名がアップロードされているかチェック
        const isImageNameExist = imageNames.every(imageName => 
           reactiveObj.newImages.some(newImage => newImage.name === imageName))
        //アップロードされていない画像ファイル名があれば、NG(確認モーダルで注意喚起)
        if(!isImageNameExist){
            reactiveImageFile.chkImgFileFlg = true
           reactiveImageFile.errImgFile = "errImgName"
            return true
        }
        return false
    }

    //firebaseの更新処理
    const userUpdate = async () => {
        //アップロードされたファイルのヘッダーの項目数を判断する（後続処理にて別手段で取得する方向性にする）
        const header = ['LastName1', 'FirstName1', 'LastName2', 'FirstName2', 'Email', 'UserOpenFlag', 'UserOpenStart', 'UserOpenEnd', 'UserGroup', 'FaceUrl']
        const registrantsId = []
        const addRegistrants = []
        const updateRegistrants = []
        const newUserList = []
        const tmpRegistrants = structuredClone(reactiveObj.registrants)
        //既存の社員番号のみを取得
        tmpRegistrants.forEach(registrantsElement => {
            registrantsId.push(registrantsElement['Id'])
        })
        //端末ID一覧を作成(FaceStatusに全端末の登録状態を設定するため)
        const terminalUUIds = []
        const Terminalslength = reactiveObj.Terminals ? Object.keys(reactiveObj.Terminals).length : 0
        if(Terminalslength !== 0){
            for(let key in reactiveObj.Terminals) {
                terminalUUIds.push(key)
            }
        }
        if(reactiveObj.newRegistrants.length > 0) {
            reactiveObj.denominatorCount = reactiveObj.newRegistrants.length
            
            //アップロードされた画像が記載された画像ファイル名に存在するかチェック
            if(!chknewImages())
            {
                alert(Error.errorResult({ code: 'RVE0011'}, route.name))
                //モーダルを表示させるため、処理から抜ける
                reactiveImageFile.uploadFileFlg = true
                reactiveObj.loadingFlag = false
                reactiveObj.otherObject = {}
                return
            }
            reactiveObj.newRegistrants.forEach(newElements => {
                //該当の変更したいIDの利用者のEメールが他の登録者と重複していないか確認
                if(checkMail(newElements)) {
                    return
                }
                //画像名の整合性チェック
                if(chkImagefile(newElements)) {
                    return
                }
                //更新対象が未登録の場合
                if(!registrantsId.includes(newElements['Id'])) {
                    addRegistrants.push(newElements)
                }
                //更新対象が登録済の場合
                else {
                    //全利用者に対して更新対象を検索
                    tmpRegistrants.forEach(registrantsElement => {
                        if(registrantsElement['Id'] == newElements['Id']){
                            let updateFlag = false
                            let changeEmailFlag = false
                            let beforeEmail = ""
                            header.forEach(headerElement => {
                                switch (headerElement) {
                                    //値が配列のもの
                                    case 'FaceUrl':
                                    case 'UserGroup': {
                                        if(headerElement == 'FaceUrl') {
                                            // 以下を満たすとき顔画像を更新する
                                            // 1.CSVに画像ファイルの列に値の記載があること
                                            // 2.顔画像のファイル名が1.の値と一致すること
                                            if (
                                                newElements['FaceStatus'].length > 0 &&
                                                newElements['FaceStatus'].some(faceStatus =>
                                                    reactiveObj.newImages.some(fileItem => fileItem.name === faceStatus)
                                                )
                                            )
                                            {
                                                //登録状況：1(登録済)を全端末分更新
                                                if(terminalUUIds.length !== 0){
                                                    registrantsElement['FaceStatus2'] = Object.fromEntries(
                                                        terminalUUIds.map(terminalUUId => [terminalUUId, FaceStatusDict['REG']])
                                                    );
                                                }
                                                else{
                                                    registrantsElement['FaceStatus2'] = {}
                                                }
                                                registrantsElement['FaceStatus'] = FaceStatusDict['REG']
                                                updateFlag = true
                                            }
                                            // 以下を満たすとき顔画像は未登録の状態にする
                                            // 1.CSVに画像ファイルの列に値の記載があること
                                            // 2.一括登録の処理であること
                                            // 3.既存の登録された顔画像に1.の値が存在していないこと
                                            else if (
                                                newElements['FaceStatus'].length > 0 &&
                                                !reactiveRegistObj.newRegistFlag &&
                                                newElements['FaceStatus'].every(faceStatus =>
                                                    !registrantsElement['FaceUrl'].includes(faceStatus)
                                                )
                                            )
                                            {
                                                //登録状況：0(未登録)を全端末分更新
                                                if(terminalUUIds.length !== 0){
                                                    registrantsElement['FaceStatus2'] = Object.fromEntries(
                                                        terminalUUIds.map(terminalUUId => [terminalUUId, FaceStatusDict['NOTREG']])
                                                    );
                                                }
                                                else{
                                                    registrantsElement['FaceStatus2'] = {}
                                                }
                                                registrantsElement['FaceStatus'] = FaceStatusDict['NOTREG']
                                                updateFlag = true
                                            }
                                        }
                                        if(JSON.stringify([...registrantsElement[headerElement]].sort()) !== JSON.stringify([...newElements[headerElement]].sort())) {
                                            registrantsElement[headerElement] = newElements[headerElement]
                                            updateFlag = true
                                        }
                                        break
                                    }
                                    case 'Email' : {
                                        if(registrantsElement[headerElement] != newElements[headerElement]) {
                                            beforeEmail = registrantsElement[headerElement]
                                            registrantsElement[headerElement] = newElements[headerElement]
                                            updateFlag = true
                                            changeEmailFlag = true
                                        }
                                        break
                                    }
                                    //それ以外
                                    default : {
                                        if(registrantsElement[headerElement] != newElements[headerElement]) {
                                            registrantsElement[headerElement] = newElements[headerElement]
                                            updateFlag = true
                                        }
                                    }
                                }
                            })
                            //更新対象があれば別のオブジェクトに更新対象のみを格納する
                            if(updateFlag) {
                                newUserList.push({
                                    execType: 'edit',
                                    userKey: registrantsElement['userId'],
                                    username: (newElements['LastName1'] && newElements['FirstName1']) ? newElements['LastName1'] + newElements['FirstName1'] :
                                        (newElements['LastName2'] && newElements['FirstName2']) ? newElements['LastName2'] + newElements['FirstName2'] : newElements['Email'],
                                    beforeEmail: beforeEmail,
                                    afterEmail: newElements['Email']
                                })
                                updateRegistrants.push(registrantsElement)
                            }
                        }
                    })
                }
            })
        }
        //画像の整合性チェックでNGだった場合
        if(reactiveImageFile.chkImgFileFlg){
            //モーダルを表示させるため、処理から抜ける
            reactiveObj.loadingFlag = false
            reactiveObj.otherObject = {}
            return
        }
        //登録者情報更新
        if(updateRegistrants.length > 0) {
            updateRegistrants.forEach(updateElement => {
                const userData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/TmpUser/${updateElement['userId']}`);
                const data = {
                    Id: updateElement['Id'],
                    FirstName1: updateElement['FirstName1'],
                    LastName1: updateElement['LastName1'],
                    FirstName2: updateElement['FirstName2'],
                    LastName2: updateElement['LastName2'],
                    Email: updateElement['Email'],
                    UserGroup: updateElement['UserGroup'],
                    FaceUrl: updateElement['FaceUrl'],
                    FaceStatus2: updateElement['FaceStatus2'],
                    FaceStatus: updateElement['FaceStatus'], 
                    UserOpenFlag: updateElement['UserOpenFlag'], 
                    UserOpenStart: updateElement['UserOpenStart'], 
                    UserOpenEnd: updateElement['UserOpenEnd'], 
                    LatestUpdated: Date.now()
                }
                update(userData, data);
            })
        }
        //新規登録者更新
        if(addRegistrants.length > 0) {
            //User情報追加
            const userPath = `CorporateId/${reactiveObj.corporateId}/TmpUser`
            //先にDBに追加する
            addRegistrants.forEach(newElements => {
                const newUserKey = push(child(databaseRef(database), userPath)).key;
                newUserList.push({
                    execType: 'regist',
                    userKey:  newUserKey,
                    username: (newElements['LastName1'] && newElements['FirstName1']) ? newElements['LastName1'] + newElements['FirstName1'] :
                        (newElements['LastName2'] && newElements['FirstName2']) ? newElements['LastName2'] + newElements['FirstName2'] : newElements['Email'],
                    beforeEmail: '',
                    afterEmail: newElements['Email']
                })
                const data = {
                    Id: newElements['Id'],
                    FirstName1: newElements['FirstName1'] === undefined ? "" : newElements['FirstName1'],
                    LastName1: newElements['LastName1'] === undefined ? "" : newElements['LastName1'],
                    FirstName2: newElements['FirstName2'] === undefined ? "" : newElements['FirstName2'],
                    LastName2: newElements['LastName2'] === undefined ? "" : newElements['LastName2'],
                    Email: newElements['Email'],
                    UserGroup: newElements['UserGroup'] === undefined ? [""] : newElements['UserGroup'],
                    FaceUrl: Array.isArray(newElements['FaceUrl']) ? newElements['FaceUrl'] : (newElements['FaceUrl'] ? [String(newElements['FaceUrl'])] : [""]),
                    FaceStatus:newElements['FaceStatus'].every(faceStatus =>
                        reactiveObj.newImages.some(fileItem => fileItem.name === faceStatus)
                    )
                        ? FaceStatusDict['REG']
                        : FaceStatusDict['NOTREG'],
                    FingerFlag: false,
                    PINFlag: false,
                    NFCFlag: false,
                    UserOpenFlag: newElements['UserOpenFlag'] === undefined ? false : newElements['UserOpenFlag'],
                    UserOpenStart: newElements['UserOpenStart'] === undefined ? 900 : newElements['UserOpenStart'],
                    UserOpenEnd: newElements['UserOpenEnd'] === undefined ? 1800 : newElements['UserOpenEnd'],
                    LatestUpdated: Date.now()
                }
                //端末一覧に1つ以上登録があれば、FaceStatusを設定
                Object.assign(data, { 
                    FaceStatus2: terminalUUIds.length > 0 ? createFaceStatus(terminalUUIds, newElements) : {}
                });

                update(databaseRef(database, `${userPath}/${newUserKey}`), data)
            })
        }
        //重複したデータがある場合
        if(reactiveObj.duplicateFlag) {
            alert(Error.errorResult({ code: 'RVE0007'}, route.name, {message: reactiveObj.duplicateMessage}))
            reactiveObj.duplicateFlag = false
            reactiveObj.duplicateMessage = ""
            return
        }

        //利用者の更新がある場合にはAPI実行で必要な処理を行う
        if(addRegistrants.length > 0 || updateRegistrants.length > 0) {
            // firebase storageに画像をアップロード
            await imageUpdate()

            reactiveCountObj.countFlag = true
            // 登録処理成功時のメッセージを初期値として設定して送る
            await callUtilFunction('登録処理が完了しました。', 'modifyUser', {
                newUserList: newUserList,
                corporateId: reactiveObj.corporateId
            })
            reactiveCountObj.countFlag = false
            reactiveObj.numeratorCount = 0
            reactiveObj.denominatorCount = 0
        }
        else {
            reactiveObj.loadingFlag = false
            reactiveObj.otherObject = {}
            showDefaultModal(`更新内容がありませんでした。`)
        }
    }
    // FaceStatus を生成する関数
    const createFaceStatus = (terminalUUIds, newElements) => {
        return Object.fromEntries(terminalUUIds.map(terminalUUId => {
            // FaceUrlの有無を判定
            const hasFaceUrl = newElements['FaceStatus'].every(facestatus =>
              reactiveObj.newImages.some(fileItem => fileItem.name === facestatus)
            )

            return [terminalUUId, hasFaceUrl ? FaceStatusDict['REG'] : FaceStatusDict['NOTREG']]; // 登録済(1) or 未登録(0)
        }));
    };

    //画像ファイルの更新
    const imageUpdate = async () => {
        const uploadPath = `/${reactiveObj.corporateId}/User/`
        await Promise.all(reactiveObj.newImages.map(async (element) => {
            const metadata = { contentType: element.type }
            const uploadref = storageRef(storage, `${uploadPath}${element['name']}`)
            await uploadBytes(uploadref, element, metadata)
        }))
    }

     //解錠可能時間を表示形式(hh:mm)に変換
    const setUserOpenTime = (UserOpenTime) => {
        let hour = Math.floor(UserOpenTime / 100)
        let minute = UserOpenTime % 100
        return hour.toString().padStart(2, '0') + "：" + minute.toString().padStart(2, '0')
    }

    //個別での利用者登録
    const registUser = () => {
        //すべての入力情報が入力されているかつ画像ファイルが選択されていること
        if(
            (
                reactiveRegistObj.newRegistrants.Id &&
                reactiveRegistObj.newRegistrants.Email
            )
        ) {
            //画像ファイルのみはこちらで更新を行う
            //画像ファイルが新規に選択されている場合にはそちらを優先する
            try {
                const imageNames = reactiveRegistObj.newImages.map(fileItem => fileItem.name);
                reactiveRegistObj.newRegistrants.FaceUrl = imageNames;
                reactiveRegistObj.newRegistrants.FaceStatus = imageNames;
            }
            //画像ファイルが選択されていない場合には既存の画像ファイルを使用する
            catch {
                if(reactiveRegistObj.index != undefined) {
                    reactiveRegistObj.newRegistrants.FaceUrl = reactiveObj.registrants[reactiveRegistObj.index].FaceUrl
                    reactiveRegistObj.newRegistrants.FaceStatus = reactiveObj.registrants[reactiveRegistObj.index].FaceStatus
                }
                else {
                    reactiveRegistObj.newRegistrants.FaceUrl = ['']
                    reactiveRegistObj.newRegistrants.FaceStatus = ['']
                }
            }
            try {
                //UserGroupが固定の時
                reactiveRegistObj.newRegistrants.UserGroup = ['All']
                //UserGroupがカスタマイズの時（UI上に入力フォームを設ける必要あり、配列の形式であること）
                //reactiveRegistObj.newRegistrants.UserGroup = (reactiveRegistObj.newRegistrants.UserGroup).split(/,/)
            } catch (error) {
                alert(Error.errorResult({ code: 'RVE0009'}, route.name))
                return
            }
            //※画像変更した場合、不一致と出る(恐らく、アップロード前に完了している？)
            reactiveObj.otherObject = {
                confirm: '登録',
                modalWidth: "40%",
            }
            const message = `以下の内容で登録します。<br>よろしいですか？<br><br>
                ID: ${reactiveRegistObj.newRegistrants.Id}<br>
                姓名: ${reactiveRegistObj.newRegistrants.LastName1 === "" && reactiveRegistObj.newRegistrants.FirstName1 === ""
                    ? "設定なし"
                    : reactiveRegistObj.newRegistrants.LastName1 + " " + reactiveRegistObj.newRegistrants.FirstName1}<br>
                フリガナ: ${reactiveRegistObj.newRegistrants.LastName2 === "" && reactiveRegistObj.newRegistrants.FirstName2 === ""
                    ? "設定なし"
                    : reactiveRegistObj.newRegistrants.LastName2 + " " + reactiveRegistObj.newRegistrants.FirstName2}<br>
                メールアドレス: ${reactiveRegistObj.newRegistrants.Email}<br>
                解錠可能時間: ${reactiveRegistObj.newRegistrants.UserOpenFlag 
                    ? setUserOpenTime(reactiveRegistObj.newRegistrants.UserOpenStart) + " ～ " + setUserOpenTime(reactiveRegistObj.newRegistrants.UserOpenEnd)
                    : "設定なし" }<br>
                画像ファイル: ${!reactiveRegistObj.newRegistrants.FaceUrl ||
                    reactiveRegistObj.newRegistrants.FaceUrl.length === 0 ||
                    (reactiveRegistObj.newRegistrants.FaceUrl.length === 1 && reactiveRegistObj.newRegistrants.FaceUrl[0] === "")
                        ? "設定なし"
                        : reactiveRegistObj.newRegistrants.FaceUrl.join("、")}`
            //更新の実行フラグ
            reactiveRegistObj.newRegistFlag = true
            showDefaultModal(message)
        }
        else {
            alert(Error.errorResult({ code: 'RVE0006'}, route.name))
        }
    }
    //既存の値をオブジェクトに格納する
    const inputRegist = (index) => {
        //再度同じ利用者を編集しようとした場合にはデータをリセット
        if(reactiveRegistObj.index == index) {
            resetExec()
            reactiveObj.userEditFlag = false
        }
        else {
            imageLabelText.value = '参照'
            reactiveRegistObj.newImages = []
            reactiveObj.renderKey++
            reactiveRegistObj.index = index
            reactiveRegistObj.newRegistrants = {
                Id: reactiveObj.registrants[index].Id,
                FirstName1: reactiveObj.registrants[index].FirstName1,
                LastName1: reactiveObj.registrants[index].LastName1,
                FirstName2: reactiveObj.registrants[index].FirstName2,
                LastName2: reactiveObj.registrants[index].LastName2,
                UserOpenFlag: reactiveObj.registrants[index].UserOpenFlag,
                UserOpenStart: reactiveObj.registrants[index].UserOpenStart,
                UserOpenEnd: reactiveObj.registrants[index].UserOpenEnd,
                //UserGroupが固定の時
                UserGroup: ['All'],
                //UserGroupがカスタマイズの時（UI上に入力フォームを設ける必要あり、配列であること）
                //UserGroup: reactiveObj.registrants[index].UserGroup,
                Email: reactiveObj.registrants[index].Email,
                FaceUrl: reactiveObj.registrants[index].FaceUrl,
                FaceStatus: reactiveObj.registrants[index].FaceStatus
            }
            reactiveRegistObj.UserOpenObj = {
                StartHour: Math.floor(reactiveObj.registrants[index].UserOpenStart / 100),
                StartMinute: reactiveObj.registrants[index].UserOpenStart % 100,
                EndHour: Math.floor(reactiveObj.registrants[index].UserOpenEnd / 100),
                EndMinute: reactiveObj.registrants[index].UserOpenEnd % 100,
            }
            reactiveObj.userEditFlag = true
            //実行後は上にスクロールさせる
            window.scroll({top: 0, behavior: 'smooth'});
        }
    }
    //利用者の削除する際に実行
    const deleteRegist = (index) => {
        //デフォルトモーダルのデザインを書き加える用のオブジェクト
        reactiveObj.otherObject = {
            index: index,
            confirm: '削除する',
            modalWidth: "40%",
        }
        const message = `以下の利用者を削除します。<br>よろしいですか？<br><br>
            ID:${ reactiveObj.registrants[index].Id}<br>
            姓名: ${reactiveObj.registrants[index].LastName1 === "" && reactiveObj.registrants[index].FirstName1 === ""
                ? "設定なし"
                : reactiveObj.registrants[index].LastName1 + " "+ reactiveObj.registrants[index].FirstName1}<br>
            フリガナ: ${reactiveObj.registrants[index].LastName2 === "" && reactiveObj.registrants[index].FirstName2 === ""
                ? "設定なし"
                : reactiveObj.registrants[index].LastName2 + " " + reactiveObj.registrants[index].FirstName2}<br>
            メールアドレス: ${reactiveObj.registrants[index].Email}<br>
            解錠可能時間: ${reactiveObj.registrants[index].UserOpenFlag 
                    ? setUserOpenTime(reactiveObj.registrants[index].UserOpenStart) + " ～ " + setUserOpenTime(reactiveObj.registrants[index].UserOpenEnd)
                    : "設定なし" }<br>
            画像ファイル: ${!reactiveObj.registrants[index].FaceUrl ||
                reactiveObj.registrants[index].FaceUrl.length === 0 ||
                (reactiveObj.registrants[index].FaceUrl.length === 1 && reactiveObj.registrants[index].FaceUrl[0] === "")
                    ? "設定なし"
                    : reactiveObj.registrants[index].FaceUrl.join("、")}`
        showDefaultModal(message)
        //削除フラグを有効化
        reactiveObj.deleteFlag = true
        //再描画
        reactiveObj.renderKey++
    }
    //処理実行後にデータをリセットする時に実行する
    const resetExec = () => {
        reactiveObj.newRegistrants = []
        reactiveObj.newImages = []
        csvLabelText.value = 'CSVファイル参照';
        imageLabelsText.value = '画像ファイル参照'
        reactiveRegistObj.newRegistFlag = false
        reactiveRegistObj.newRegistrants = {
            ID: '',
            FirstName1: '',
            LastName1: '',
            FirstName2: '',
            LastName2: '',
            UserOpenFlag: false,
            UserOpenStart: 0,
            UserOpenEnd: 0,
            FaceUrl: [],
            FaceStatus: [],
            UserGroup: []
        },
        reactiveRegistObj.UserOpenObj = {
            StartHour: 0,
            StartMinute: 0,
            EndHour: 0,
            EndMinute: 0
        }
        reactiveRegistObj.newImages = []
        reactiveRegistObj.index = undefined
        reactiveObj.imageFlag = false
        reactiveObj.userEditFlag = false
        imageLabelText.value = '参照';
        reactiveObj.renderKey++
    }
    //デフォルトのモーダルを開く際に実行
    const showDefaultModal = (message) => {
        //ローディング終了
        reactiveObj.loadingFlag = false
        //モーダルを表示
        reactiveObj.modalFlag = true
        //モーダル上の表示する文面
        reactiveObj.modalMessage = message
        //モーダル部分を再描画
        reactiveObj.modalRenderkey++
    }
    //デフォルトのモーダルを閉じる際に実行
    const closeDefaultModal = async (editFlag) => {
        //登録完了時のCSV吐き出す処理
        if(reactiveObj.outputData) {
            outputCSVData(reactiveObj.outputData)
            reactiveObj.outputData = ""
        }
        //削除実行フラグが有効化かつ同意している場合
        if(reactiveObj.deleteFlag && editFlag) {
            //ローディング開始
            reactiveObj.loadingFlag = true
            //削除対象のインデックス番号を取得
            const index = reactiveObj.otherObject.index
            //削除対象のEメール
            const Email = reactiveObj.registrants[index].Email
            //削除APIの実行
            callUtilFunction('削除が完了いたしました。', 'deleteUser', {
                targetEmailList: [Email],
                corporateId: reactiveObj.corporateId,
                force: false
            })
        }
        //画像ファイル整合性チェック 注意確認に同意している場合
        if(reactiveImageFile.confirmFlg  && editFlag){
            //モーダルを閉じる            
            reactiveObj.loadingFlag = true
            reactiveObj.modalFlag = false
            //登録処理を行う
            userUpdate()
            //リセット処理
            resetExec();
        }
        //個別登録フラグが有効化かつ同意の場合
        if(reactiveRegistObj.newRegistFlag && editFlag) {
            reactiveObj.deleteFlag = false
            reactiveObj.otherObject = {}
            reactiveImageFile.confirmFlg = false
            //確認モーダルを先に閉じてから登録処理を開始する
            reactiveObj.modalFlag = false
            //更新対象は一人しかいないが既存処理に合わせてオブジェクトを格納する
            reactiveObj.newRegistrants = [reactiveRegistObj.newRegistrants]
            reactiveObj.newImages = reactiveRegistObj.newImages
            //既存処理と同様に登録処理を行う
            uploadExec()
            return
        }

        //削除フラグを無効化
        reactiveObj.deleteFlag = false
        reactiveObj.otherObject = {}
        //画像ファイル整合性チェック 注意確認 フラグを無効化
        reactiveImageFile.confirmFlg = false

        //モーダルを閉じる
        reactiveObj.modalFlag = false
    }
    //登録中の件数を計測（リアルタイム更新）
    const getExecUserCount = () => {
        const settingsRef = databaseRef(database, `LoginUser/${auth.currentUser.uid}/ExecUserDataCount`)
            //firebaseからアプリ情報を取得する（戻り値はリスナー解除関数）
            return onValue(settingsRef, (snapshot) => {
                reactiveObj.numeratorCount = snapshot.val() ? snapshot.val() : 0
            })
    }
    //Nページ目に表示する利用者情報を取得
    const getItems = computed(() => {
        let current = reactiveObj.currentPage * perPage;
        let start = current - perPage;
        return reactiveObj.registrants.slice(start, current);
    })
    //現在のページ数を取得
    const getPageCount = computed(() => {
        return Math.ceil(reactiveObj.registrants.length / perPage) ? Math.ceil(reactiveObj.registrants.length / perPage) : 1
    })

    //削除後にページ数が減った場合の調整
    const adjustPagecount = async () => {
        //現在のページを再計算
        const maxPage = Math.ceil(reactiveObj.registrants.length / perPage) ? Math.ceil(reactiveObj.registrants.length / perPage) : 1
        //削除後にページ数が減った場合、現在のページ = 全体のページ数とする
        if (reactiveObj.currentPage > maxPage) {
            reactiveObj.currentPage = Number(maxPage);
            //モーダルウィンドウを再描画
            reactiveObj.renderKey++
        }
    }

    //解錠可能時間(時間) プルダウン表示用
    const hourOptions = computed(() => {
        return Array.from({ length: 24 }, (_, i) => i)
    })
    //解錠可能時間(分) プルダウン表示用
    const minuteOptions = computed(() => {
        return Array.from({ length: 4 }, (_, i) => i * 15)
    })

    //HHMMの形式に合わせて4桁の数値でそれぞれ開始と終了の値を計算する
    const registUserOpenTime = (setSpan) => {
        setSpan == 'start' ? reactiveRegistObj.newRegistrants.UserOpenStart = Number(reactiveRegistObj.UserOpenObj.StartHour * 100) + Number(reactiveRegistObj.UserOpenObj.StartMinute):
            reactiveRegistObj.newRegistrants.UserOpenEnd = Number(reactiveRegistObj.UserOpenObj.EndHour * 100) + Number(reactiveRegistObj.UserOpenObj.EndMinute)
    }

    //端末毎のFaceStatusから表示内容を設定
    const dispFaceStatus = (FaceStatus2) => {

        const values = Object.values(FaceStatus2); //FaceStatus2の値を取得
        let message = "未登録"; //特徴量データのステータス
        let isDisabled = true; //クリッカブル表示の制御
        let defalutModalMsg = "" //モーダルで表示するメッセージ
        
        // FaceStatus2が未設定の場合、未登録の状態
        if(values.length === 0) return { message, isDisabled, defalutModalMsg }

        //3(未検出)の状態の端末が存在している
        if (values.includes(FaceStatusDict['NOTEMB'])) {
            message = "登録エラー";
            isDisabled = false;
            defalutModalMsg =  `特徴量の抽出に失敗しました。<br>
                再度、顔画像を登録してください。`
        }
        //すべての端末の状態が2(読込済)
        else if (values.every(v => v === FaceStatusDict['CMPREAD'])) {
            message = "登録済";
        }
        //すべての端末の状態が1(登録済)
        else if (values.every(v => v === FaceStatusDict['REG'])) {
            message = "登録中";
        }
        //すべての端末の状態が 1(登録済)、2(読込済)、4(一部の画像のみ登録済み)のいづれか
        else if (values.every(v => v === FaceStatusDict['REG'] || v === FaceStatusDict['CMPREAD'] || v === FaceStatusDict['READING'])) {
            message = "登録中";
            isDisabled = false;

            //statusが1または4の端末Iの端末名を取得
            const terminalNames = [];
            for (const [id, status] of Object.entries(FaceStatus2)) {
                if ( ((status === FaceStatusDict['REG']) || (status === FaceStatusDict['READING'])) && reactiveObj.Terminals[id]) {
                    //親機と子機は端末名が一緒なので、親機/子機を表示する
                    reactiveObj.Terminals[id].TerminalType == "child" ? 
                    terminalNames.push(reactiveObj.Terminals[id].TerminalName + "(子機)") :
                    reactiveObj.Terminals[id].TerminalType == "parent" ?
                    terminalNames.push(reactiveObj.Terminals[id].TerminalName + "(親機)") :
                    terminalNames.push(reactiveObj.Terminals[id].TerminalName)
                }
            }
            // 端末名を「、」でつなげて羅列
            let terminalNamesMsg = terminalNames.join("、")
            // 表示メッセージの設定
            defalutModalMsg = `以下の端末で特徴量を取得中です。<br>
                ${ terminalNamesMsg }<br>
                取得完了まで少々お待ちください。`
        }
        
        return { message, isDisabled, defalutModalMsg };
    }

    let unsubscribeRegstrants = null
    let unsubscribeExecUserCount = null

    onMounted(async () => {
        reactiveObj.corporateId = await utilFunctions.getCorporateId()
        reactiveObj.appSetting = await utilFunctions.getAppSetting(reactiveObj.corporateId)
        reactiveObj.Terminals = await utilFunctions.getTerminals(reactiveObj.corporateId)
        unsubscribeRegstrants = await getRegstrants()
        unsubscribeExecUserCount = getExecUserCount()
    })

    onUnmounted(() => {
        unsubscribeRegstrants?.()
        unsubscribeExecUserCount?.()
    })
</script>

<template>
    <HeaderComponent></HeaderComponent>
    <NavigationBar></NavigationBar>
    <main>
        <div id="loadingDisplay" class="loading" v-show="reactiveObj.loadingFlag">
            <div class="load-text load-blink" v-show="!reactiveCountObj.countFlag">処理中...</div>
            <div v-show="reactiveCountObj.countFlag">
                <div class="load-text load-blink">登録中...{{ Math.min(Math.ceil(reactiveObj.numeratorCount / (reactiveObj.denominatorCount * 2) * 100), 100) }}%
                </div>
                <progress v-bind:max="reactiveObj.denominatorCount ? reactiveObj.denominatorCount*2 : 0" v-bind:value="reactiveObj.numeratorCount" class="progress"></progress>
            </div>
        </div>
        <div class="userRegistration" :key="reactiveObj.renderKey">
            <div class="noneDesktop">
                <div class="titleArea">
                    <p class="title">利用者登録</p>
                </div>
                <div class="inputArea">
                    <div class="inputUserArea">
                        <div id="inputUser1">
                            <p>ID</p>
                            <input type="text" id="inputId" v-model="reactiveRegistObj.newRegistrants.Id" v-bind:disabled="reactiveObj.userEditFlag">
                        </div>
                        <div id="inputUser2">
                            <p>姓</p>
                            <input type="text" id="inputLastName1" v-model="reactiveRegistObj.newRegistrants.LastName1">
                        </div>
                        <div id="inputUser3">
                            <p>名</p>
                            <input type="text" id="inputFirstName1" v-model="reactiveRegistObj.newRegistrants.FirstName1">
                        </div>
                        <div id="inputUser4">
                            <p>セイ</p>
                            <input type="text" id="inputLastName2" v-model="reactiveRegistObj.newRegistrants.LastName2">
                        </div>
                        <div id="inputUser5">
                            <p>メイ</p>
                            <input type="text" id="inputFirstName2" v-model="reactiveRegistObj.newRegistrants.FirstName2">
                        </div>
                    </div>
                    <div class="inputUserArea">
                        <div id="inputUser6">
                            <p>メールアドレス</p>
                            <input type="text" id="inputMail" v-model="reactiveRegistObj.newRegistrants.Email">
                        </div>
                    </div>
                    <div class="inputUserArea">
                        <div id="inputUser8">
                            <div class="tooltip-wrapper">
                                <p class="tooltip-content" id="tooltip-useropen" v-show="reactiveObj.tipsUserOpenFlag">利用者ごとに解錠可能な時間を設定できます。</p>
                                <p>解錠可能時間<img @mouseenter="tipsHoverUserOpen" @mouseleave="tipsLeaveUserOpen" src="../../assets/tips_icon.svg" class="tips"></p>
                            </div>
                            <div class="switchArea" id="switchAreaUserReg">
                                <p class="switchLabel" v-if = "reactiveRegistObj.newRegistrants.UserOpenFlag">ON</p>
                                <p class="switchLabel" v-else>OFF</p>
                                <label>
                                    <input type="checkbox" v-model="reactiveRegistObj.newRegistrants.UserOpenFlag">
                                    <div id="swImg"></div>
                                </label>
                            </div>
                        </div>
                        <div id="inputUser9">
                           <p>　</p>
                           <div class="setUserOpenTime">
                                <select 
                                    class="setTime setStartHour" 
                                    v-model="reactiveRegistObj.UserOpenObj.StartHour"
                                    :disabled="!reactiveRegistObj.newRegistrants.UserOpenFlag" 
                                    @change="registUserOpenTime('start')">
                                    <option v-for="hour in hourOptions" :key="hour" :value="hour">
                                        {{ hour.toString().padStart(2, '0') }}時
                                    </option>
                                </select>
                                <select 
                                    class="setTime setStartMinute" 
                                    v-model="reactiveRegistObj.UserOpenObj.StartMinute" 
                                    v-bind:disabled="!reactiveRegistObj.newRegistrants.UserOpenFlag" 
                                    @change="registUserOpenTime('start')">
                                    <option v-for="minute in minuteOptions" :key="minute" :value="minute">
                                        {{ minute.toString().padStart(2, '0') }}分
                                    </option>
                                </select>
                                <p class="whiteSpace">～</p>
                                <select 
                                    class="setTime setEndHour" 
                                    v-model="reactiveRegistObj.UserOpenObj.EndHour" 
                                    v-bind:disabled="!reactiveRegistObj.newRegistrants.UserOpenFlag" 
                                    @change="registUserOpenTime('end')">
                                    <option v-for="hour in hourOptions" :key="hour" :value="hour">
                                        {{ hour.toString().padStart(2, '0') }}時
                                    </option>
                                </select>
                                <select 
                                    class="setTime setEndMinute" 
                                    v-model="reactiveRegistObj.UserOpenObj.EndMinute" 
                                    v-bind:disabled="!reactiveRegistObj.newRegistrants.UserOpenFlag" 
                                    @change="registUserOpenTime('end')">
                                    <option v-for="minute in minuteOptions" :key="minute" :value="minute">
                                        {{ minute.toString().padStart(2, '0') }}分
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div id="inputUser7">
                            <div class="tooltip-wrapper">
                                <div class="tooltip-content" id="tooltip-img" v-show="reactiveObj.tipsImgFlag">
                                    画像は一人につき<br>5枚まで登録できます。<br>画像を多く登録することで、<br>顔認証の精度を向上できます。
                                </div>
                                <p>画像ファイル<img @mouseenter="tipsHoverImg" @mouseleave="tipsLeaveImg" src="../../assets/tips_icon.svg" class="tips"></p>
                            </div>
                            <label id="imageLabel"><span v-html="imageLabelText"></span><input type="file" id="imageButton" @change="imageUpload" multiple></label>
                        </div>
                        <div id="inputUser8">
                            <p>　</p>
                            <input type="button" id="inputExec" @change="oneUploadExec" value="確認" @click="registUser">
                        </div>
                    </div>
                </div>
                <div class="userRegistArea">
                    <div class="subTitleArea">
                        <p class="subTitle editTitle">利用者一括登録</p>
                        <button id="format" @click="outputCSVData('', true)">CSVフォーマットのダウンロード</button>
                    </div>
                    <div class="userBulkRegist">
                        <label id="csvLabel"><span v-html="csvLabelText"></span><input type="file" id="csvButton" @change="fileUpload"></label>
                        <label id="imageLabels"><span v-html="imageLabelsText"></span><input type="file" id="imageButtons" @change="imageUpload" multiple></label>
                        <label id="uploadLabel">アップロード<button type="button" id="uploadButton" @click="uploadExec"></button></label>
                    </div>
                </div>
            </div>
            <div class="registrants">
                <div class="subTitleArea">
                    <p class="subTitle">登録者一覧</p>
                </div>
                <div class="tableArea">
                    <table class="commonTable">
                        <tbody>
                            <tr>
                                <th>ID</th>
                                <th v-if="reactiveObj.appSetting.UseName1">姓名</th>
                                <th v-if="reactiveObj.appSetting.UseName2">フリガナ</th>
                                <th class="leftSideTh">メールアドレス</th>
                                <th>特徴量データ</th>
                                <th>解錠可能時間</th>
                                <!-- Sesame Touch機能 リリースまで首締め(動作確認済)
                                <th>タッチ情報</th>
                                -->
                                <th class="noneDesktop">編集</th>
                                <th class="noneDesktop">削除</th>
                            </tr>
                            <tr v-for="(data, key) in getItems" :key="key">
                                <td id="userid" >{{ data.Id }}</td>
                                <td id="usename1" v-if="reactiveObj.appSetting.UseName1">{{ data.LastName1 }} {{ data.FirstName1 }}</td>
                                <td id="usename2" v-if="reactiveObj.appSetting.UseName2">{{ data.LastName2 }} {{ data.FirstName2 }}</td>
                                <td class="leftSideTd">{{ data.Email }}</td>
                                <td id="facestatus"
                                    :class="{ nonmodal: dispFaceStatus(data.FaceStatus2).isDisabled }"
                                    @click=" !dispFaceStatus(data.FaceStatus2).isDisabled ? 
                                        showDefaultModal(dispFaceStatus(data.FaceStatus2).defalutModalMsg) :
                                        null"
                                >
                                   {{ dispFaceStatus(data.FaceStatus2).message }}
                                </td>
                                <td>{{ data.UserOpenFlag ? setUserOpenTime(data.UserOpenStart) + " ～ " + setUserOpenTime(data.UserOpenEnd): "ー"}}</td>
                                <!-- Sesame Touch機能 リリースまで首締め(動作確認済)
                                <td>{{ displayTouchInfo(data) }}</td>
                                -->
                                <td class="noneDesktop"><button type="button" class="editButton" ><img src="../../assets/pencil.png" id="pencilIcon" @click="inputRegist((reactiveObj.currentPage-1)*perPage+key)"></button>
                                </td>
                                <td class="noneDesktop"><button type="button" class="deleteButton"><img src="../../assets/delete.png" id="deletelIcon" @click="deleteRegist((reactiveObj.currentPage-1)*perPage+key)"></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <DefaultModalComponent
                :key="reactiveObj.modalRenderkey"
                :modalMessage="reactiveObj.modalMessage"
                :otherObject="reactiveObj.otherObject"
                v-show="reactiveObj.modalFlag"
                @executeMethod="closeDefaultModal">
            </DefaultModalComponent>
        </div>
        <div class="paginationArea">
            <PaginateComponent
                :page-count="getPageCount"
                :click-handler="clickCallback"
                :page-range="5"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :force-page="reactiveObj.currentPage">
            </PaginateComponent>
        </div>
    </main>
</template>

<style scoped>
    .progress {
        width: 500px;
        height: 100px;
    }
    .userRegistration {
        padding: 0 5% 0 25%;
        background: #e7e6e6;
    }
    .inputArea {
        padding: 20px 5% 20px 5%;
        background-color: #F5F5F5;
        width: 90%;
    }
    .inputUserArea {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0 0 10px 0;
        gap: 3%;
    }
    [id^="inputUser"] {
        width: 93%;
    }
    #inputUser6 {
        width: 60%;
    }
    #inputUser8 {
        width: 90%;
    }
    #inputUser9 {
        left: 0%;
    }
    .setUserOpenTime {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 0%;
    }
    .setTime {
        height: 55px;
        width: 90px;
        text-align: center;
        border-radius: 10px;
        border: solid 2px #999999;
        background-color: #EEEEEF;
        margin:0 5px 0 5px
    }
    [id^="inputUser"] input {
        width: 100%;
        height: 55px;
        border-radius: 10px;
        border: 2px solid #999;
    }
    [id^="inputUser"] p {
        text-align: left;
    }
    #inputMail {
        width: 100%;
    }
    #imageLabel {
        width: 100%;
        height: 55px;
        border: 3px solid #d7d7d7;
        border-radius: 10px;
        background-color: #d7d7d7;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #inputFile:active {
        transform: translate(0,2px);
    }
    #inputExec {
        width: 102%;
        height: 60px;
        padding: 0 12px 0 0;
        border: none;
        background-color: #00AEEB;
        color: #FFFFFF;
    }
    .userBulkRegist {
        display: flex;
        height: 100px;
        align-items: center;
        justify-content: space-between;
        gap: 10%;
        background-color: #F5F5F5;
        padding: 0 5% 0 5%;
    }
    .editTitle {
        padding: 5% 0 0 0;
    }
    #format {
        position: relative;
        display: flex;
        margin-left: auto;
        top: -40px;
        border: solid 3px #00AEEB;
        background: #00AEEB;
        color: #FFFFFF;
    }
    #csvButton, #imageButton, #imageButtons, #uploadButton, #resetButton {
        display: none;
    }
    .userBulkRegist #csvLabel {
        position: relative;
        width: 30%;
        height: 60%;
        font-size: 100%;
        line-height: 55px;
        border-radius: 10px;
        border: solid 3px #d7d7d7;
        background-color: #d7d7d7;
    }
    .userBulkRegist #imageLabels {
        width: 30%;
        height: 60%;
        font-size: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        border: solid 3px #d7d7d7;
        background-color: #d7d7d7;
    }
    .userBulkRegist #uploadLabel {
        width: 30%;
        height: 60%;
        font-size: 100%;
        line-height: 55px;
        border-radius: 10px;
        border: solid 3px #00AEEB;
        background-color: #00AEEB;
        color: #FFFFFF;
    }
    .userBulkRegist #resetLabel {
        width: 30%;
        font-size: 100%;
        border-radius: 10px;
        border: solid 3px #ed68c1;
        background-color: #edcce2;
    }
    #switchAreaUserReg{
        left: 15%;
        width: 80%;
    }
    #facestatus{
        cursor: pointer;
        color: #0d6efd;
        text-decoration: underline;
        border-color: #4a4a4a;
        white-space: nowrap;
    }
    .nonmodal {
        pointer-events: none;
        cursor: default;
        color: #3f3f3f !important;
        text-decoration: none !important;
    }
   
    @media (max-width: 1150px) {
        .userRegistration{
            padding: 0 5% 0 5%;
        }
        .noneDesktop {
            display: none;
        }
        .tableArea {
            overflow-x: scroll;
        }
        .commonTable tr:first-child>*:nth-last-child(3) {
            border-radius: 0 20px 0 0;
        }
        .subTitleArea {
            height: 60px;
        }
        .subTitle {
            padding: 0 0 0 0;
        }
        .commonTable th {
            padding: 0 10px;
        }
        #userid, #usename1, #usename2
        {
            white-space: nowrap;
            padding: 0 10px;
        }
        #facestatus{
            word-break: keep-all;
            white-space: normal;
        } 
    }
</style>
